import React from "react";
import { connect } from "react-redux";

import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow,
  Selection
} from "devextreme-react/data-grid";
import OutsideClickHandler from "react-outside-click-handler";
import CachedIcon from "@material-ui/icons/Cached";
import { withStyles } from "@material-ui/core/styles";

import { columns } from "./utils";
import SquareButton from "../../../../ui/SquareButton";
import SearchField from "../../../../ui/SearchField";
import ActionsMenu from "../../../../ui/ActionsMenu";
import Box from "../../../../ui/Box";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
    "& > div": {
      display: "flex",
      alignItems: "flex-end",
      "& > *:not(:nth-last-child(1))": {
        marginRight: "14px"
      }
    }
  }
};

class ExpertiseTable extends React.Component {
  constructor(props) {
    super(props);

    this.searchByText = this.searchByText.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.dataGridRef = React.createRef();
  }

  searchByText(e) {
    const text = e.target.value;
    this.dataGridRef.current.instance.searchByText(text);
  }

  onRowClick(e) {
    console.log(e.data.id);
    //const focusedFacility = e !== -1 ? e.data.id : e;
    //const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    //this.setState({ focusedFacility, focusedRowIndex });
  }

  render() {
    const {
      classes,
      expertiseList,
      getExpertiseList
    } = this.props;
    const { root, expertContainer, controls } = classes;

    const expertActions = [
      {
        label: "Выбор видимых столбцов",
        disabled: true
      }
    ];

    return (
      <div className={root}>
        <Box>
          <div className={controls}>
            <div>
              <SquareButton>
                <CachedIcon fontSize="small"/>
              </SquareButton>
              <SearchField width={400} />
            </div>
            <div>
              <ActionsMenu actions={expertActions} />
            </div>
          </div>
          <div>
            <DataGrid
              elementAttr={{
                id: "gridContainer"
              }}
              ref={this.dataGridRef}
              dataSource={expertiseList}
              onRowClick={this.onRowClick}
              wordWrapEnabled={true}
              focusedRowEnabled
              errorRowEnabled={false}
              showBorders
            >
              <Selection mode="single"/>
              {columns.map(column => (
                <Column key={column.dataField} {...column} />
              ))}
              <FilterRow visible={true} />
              <Scrolling mode="virtual" />
              <LoadPanel enabled />
            </DataGrid>
          </div>
        </Box>
      </div>
    );
  }
}

export default withStyles(styles)(ExpertiseTable);
